export enum WithdrawalsQueryKeys {
  Primary = 'withdrawals',
  ById = 'withdrawals/:id',
  Fee = 'withdrawals/fee',
  TokenLookup = '/withdrawals/token-lookup',
}
